function parseCheck(value) {
  let entry = "";
  try {
    entry = JSON.parse(value);
  } catch (_e) {
    entry = value;
  }

  return entry;
}

export { parseCheck };
